import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';
import { CustomerSelectionComponent } from '../../../components/popUpSelects/customer-selection/customer-selection.component';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';

@Component({
    selector: 'app-angie-screen-editor',
    templateUrl: './angie-screen-editor.component.html',
    styleUrls: ['./angie-screen-editor.component.scss'],
    providers: [AngieScreensService, OrganisationCustomerService],
    standalone: false
})
export class AngieScreenEditorComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;
  pageActions: PageAction[];

  title = 'Edit Angie Screen';
  create = false;
  isLoading = true;
  screen: Models.AngieScreen;
  screenId: string;
  organisationCustomer;

  constructor(
    private angieScreensService: AngieScreensService,
    private organisationCustomerService: OrganisationCustomerService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService,
    private router: Router,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.screenId = this.activatedRoute.snapshot.params['id'];
    if (this.screenId) {
      this.angieScreensService.get(this.screenId).then(response => {
        this.screen = response;
        this.title = 'Edit screen: ' + this.screen.name;
        this.isLoading = false;
        this.loadForm();
        this.fetchOrganisationCustomer();
        this.createPageActions();
      });
    } else {
      this.title = 'Create new organisation customer';
      this.create = true;
      this.screen = <Models.AngieScreen>Models.ModelFactory.createModelInstanceByName('AngieScreen');
      this.isLoading = false;
      this.loadForm();
    }
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.screen;
  }

  onSave() {
    return this.screen.validate(true).then(result => {
      if (result.success) {
        if (this.screenId) {
          this.angieScreensService.update(this.screenId, this.screen).then(screen => {
            this.snackbar.success('Successfull updated screen');
          });
        } else {
          this.angieScreensService.create(this.screen).then(screen => {
            this.snackbar.success('Successfull created new screen');
            this.router.navigate(['angie-screens', screen._id, 'edit']);
          });
        }
      } else {
        this.snackbar.open('Could not create the screen, please fill the form correctly');
      }
    });
  }

  public assignCustomer() {
    let dialogRef: MatDialogRef<CustomerSelectionComponent>;
    const config: MatDialogConfig = {
      data: {
        ids: [this.screen.organisationCustomerId],
        angieOnly: true
      }
    };

    dialogRef = this.dialog.open(CustomerSelectionComponent, config);

    return dialogRef.afterClosed().toPromise().then(result => {
      if (result && result.customerId) {
        this.screen.organisationCustomerId = result.customerId;
        this.fetchOrganisationCustomer();
      }
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'info',
        title: 'Detail screen',
        hidden: !this.screenId,
        callback: () => {
          this.router.navigate(['angie-screens', this.screenId]);
        }
      }),
      new PageAction({
        icon: 'info',
        title: 'Assign customer',
        callback: () => {
          this.assignCustomer();
        }
      })
    ];
  }

  private fetchOrganisationCustomer() {
    if (this.screen && this.screen.organisationCustomerId) {
      this.organisationCustomerService.find(0, 1, { _id: this.screen.organisationCustomerId }).then(organisationCustomer => {
        if (organisationCustomer.data && organisationCustomer.data.length) {
          this.organisationCustomer = organisationCustomer.data[0].organisationName;
          return;
        }
      })
    }
  }

}
